exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact-dealer-form__title[data-v-64aab46e]{font-weight:700;font-size:16px;text-align:left;margin-bottom:10px;margin-left:auto\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64aab46e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/used-vue/components/ContactDealerForm.vue
// module id = RxH7
// module chunks = 4 5